import React, { useContext, useEffect, useRef, useState } from 'react';
import { WelletContext } from '../../../context/WelletContext';
import BottomSheet from '../../../components/BottomSheet/BottomSheet';
import { useDispatch, useSelector } from 'react-redux';
import { setCanRefresh } from '../../../actions/appActions';

import { getQueryString } from '../../../helpers/url';
import { CircleSpinner } from 'react-spinners-kit';
import Header from '../../../components/Common/Header/Header';
import Button from '../../../components/Common/Button/Button';
import { useTranslation } from 'react-i18next';
import styles from '../../Venue/VenueDetail/VenueDetail.module.css';

import { formatDateNormal, getLocale } from '../../../helpers/dates';
import { format } from 'date-fns';
import ContentApp from '../../../components/ContentApp';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Navigation, Pagination } from 'swiper/modules';
import Image from '../../../components/Image/Image';
import BottomSheetComponent from '../../../components/BottomSheet/BottomSheet';

const EventDetail = ({ history }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const welletContext = useContext(WelletContext);
  const language = useSelector((state) => state.app.language);
  const locale = getLocale(language);

  const eventId = getQueryString('eventId');
  const [loading, setLoading] = useState(true);
  const [event, setEvent] = useState(null);
  const buttonTypes = ['TICKET', 'AREA'];
  const swiperRef = useRef(null);

  const getEvent = async () => {
    try {
      const result = await welletContext.apis.tickets.get('/shows/event/' + eventId, {
        params: { lang: language },
      });

      setEvent(result.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const headerHtml = () => {
    return (
      <div className='mt-3'>
        <h1 className='font-large m-0'>{event.name}</h1>
        <span className='text-secondary'>{event.show.name}</span>
        <div className='fw-bold mt-3'>
          <div>{formatDateNormal(event.startDate, locale)}</div>
          <div>{format(new Date(event.startDate), 'h:mm aaa')}</div>
        </div>
      </div>
    );
  };

  const handleClick = (nameId) => {
    let query = `?eventId=${eventId}&showId=${event.show.id}`;

    if (nameId) {
      query += `&type=${nameId}`;
    }

    history.push({
      pathname: '/ticket-selector',
      search: query,
    });
  };

  const renderButtons = () => {
    return (
      <div className='mt-3 pt-3' style={{ borderTop: '1px solid #3d3d3d' }}>
        {event.reservationTypes
          .filter((type) => buttonTypes.includes(type))
          .sort((a, b) => buttonTypes.indexOf(a) - buttonTypes.indexOf(b))
          .map((item, index) => (
            <div className='mb-2' key={index}>
              <Button
                backgroundColor={index === 0 ? '#fff' : 'var(--color-primary)'}
                onClick={() => handleClick(item)}
                size={'normal'}
                text={t('reservationTypes.' + item)}
              />
            </div>
          ))}
      </div>
    );
  };

  const renderButtonSimple = () => {
    return (
      <div className='mt-3 pt-3' style={{ borderTop: '1px solid #3d3d3d' }}>
        <div className='mb-2'>
          <Button
            size={'normal'}
            text={t('comingSoonMin')}
            backgroundColor={'rgba(255, 255, 255, 0.781)'}
            color={'#000'}
          />
        </div>
      </div>
    );
  };

  const getLocation = () => {
    const address = event.show.address.split(',').map((str) => str.trim());
    const textCity = event.show.city.nameLong.split(',').map((str) => str.trim());
    let secondLine = event.show.postalCode;

    if (address.length > 1) secondLine = `${address[1]}, ${secondLine}`;

    return (
      <div>
        <div>{address[0]}</div>
        <div>{secondLine}</div>
        <div>{`${textCity[0]}, ${textCity[1]}`}</div>
        <div>{textCity[2]}</div>
      </div>
    );
  };

  const contentHtml = () => {
    return (
      <div style={{ paddingBottom: 'calc(2rem + env(safe-area-inset-bottom))' }}>
        {event?.reservationTypes?.length > 0 ? renderButtons() : null}
        {/* renderButtonSimple() */}
        <div className='hide-content'>
          {event.description && event.description.length > 0 && (
            <div className='mt-3 pt-4' style={{ borderTop: '1px solid #3d3d3d' }}>
              <div className='fw-bold'>{t('about')}</div>
              <div
                className='text-lighter-gray mt-2'
                dangerouslySetInnerHTML={{ __html: event.description }}
              />
            </div>
          )}

          <div className='mt-4 pt-4' style={{ borderTop: '1px solid #3d3d3d' }}>
            <div className='fw-bold'>{t('location')}</div>
            <div className='text-lighter-gray mt-2'>{getLocation()}</div>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    dispatch(setCanRefresh(false));
    getEvent();
    return () => {
      dispatch(setCanRefresh(true));
    };
  }, []);

  return (
    <>
      {loading ? (
        <div className='loaderDiv'>
          <CircleSpinner
            className='spinner-app mx-auto'
            style={{ margin: 'auto' }}
            size={40}
            color='var(--color-font-primary)'
          />
        </div>
      ) : (
        <>
          <Header absolute={true} color='#fff' />
          <ContentApp classes='p-0 overflow-hidden'>
            <div className={styles.pageHeader}>
              <div className={`${styles.pageSection} ${styles.header}`}>
                <div className={styles.background}>
                  <Swiper
                    ref={swiperRef}
                    className={`swiper-show ${styles.swiperContainer} custom-swiper `}
                    pagination={true}
                    modules={[Navigation, Pagination]}
                    style={{
                      '--swiper-pagination-bottom': 'none',
                      '--swiper-pagination-color': '#fff',
                      '--swiper-pagination-bullet-inactive-color': '#999999',
                      '--swiper-pagination-bullet-inactive-opacity': '1',
                      '--swiper-pagination-bullet-size': '7px',
                      '--swiper-pagination-bullet-horizontal-gap': '6px',
                    }}
                  >
                    <SwiperSlide>
                      <div className={styles.overlay}>
                        <Image src={event.imageUrl} alt={event.name} size='MEDIUM' />
                      </div>
                    </SwiperSlide>

                    {event &&
                      [...(event.images || []), ...(event.videos || [])].map((media, index) => (
                        <SwiperSlide key={index}>
                          <div className={styles.overlay}>
                            {!media.media.includes('.mp4') ? (
                              <Image src={media.media} alt={media.title} size='MEDIUM' />
                            ) : (
                              <video
                                webkit-playsinline='true'
                                x5-playsinline='true'
                                playsInline
                                autoPlay
                                loop
                                muted
                                src={media.media}
                                alt='media'
                                style={{ width: '100%' }}
                              />
                            )}
                          </div>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </div>
              </div>
            </div>
            <BottomSheetComponent
              header={
                <div className='mt-4 text-left'>
                  <h1 className='font-large m-0 fw-600'>{event.name}</h1>
                  <span className='text-secondary'>{event.show.name}</span>
                  <div className='fw-bold mt-3'>
                    <div>{formatDateNormal(event.startDate, locale)}</div>
                    <div>{format(new Date(event.startDate), 'h:mm aaa')}</div>
                  </div>
                </div>
              }
              content={contentHtml()}
            /> 
          </ContentApp>
        </>
      )}
    </>
  );
};

export default EventDetail;
